module.exports = __webpack_public_path__ + "media/images/thank-you-7441c7f7348c34be468d7e66742a2b39.png";